import React from "react";
import { industries } from "../data/siteContent";

export default function Industries() {
  return (
    <section className="page-hero">
      <p className="eyebrow">Industries</p>
      <h1>Labor support for logistics teams that measure time by dock doors.</h1>
      <p>We support importers, warehouses, fulfillment teams, manufacturers, and distribution centers with trained crews that fit into existing site processes.</p>
      <div className="industry-grid">
        {industries.map((industry) => (
          <article key={industry}>
            <h2>{industry}</h2>
            <p>Flexible unloading and freight handling support shaped around your product mix, schedule, and warehouse flow.</p>
          </article>
        ))}
      </div>
    </section>
  );
}
